import React from "react"
import Link from 'gatsby-link'

// Get react/gatsby components
import LocationGridItem from '../LocationGridItem'

class LocationGrid extends React.Component {

  render() {
    return (
      <div>
        <article className="pfb-location-grid-container">
          <section className="pfb-location-grid-row">
            <LocationGridItem location="Arizona" path="/arizona" id="1" />
            <LocationGridItem location="Albany, NY" path="/albany" id="7" />
            <LocationGridItem location="Park City, UT" path="/park-city" id="11" />
            <LocationGridItem location="Huntsville, AL" path="/huntsville" id="17" />
            <LocationGridItem location="Detroit, MI" path="/detroit" id="10" />
            <LocationGridItem location="Charlotte, NC" path="/charlotte" id="16" />
            <LocationGridItem location="Montana" path="/montana" id="1" />
            <LocationGridItem location="Washington, DC" path="/washington-dc" id="12" />
            <LocationGridItem location="Wisconsin" path="/wisconsin" id="6" />
            <LocationGridItem location="Port Angeles, WA" path="/port-angeles" id="18" />
            <LocationGridItem location="Las Vegas, NV" path="/las-vegas" id="19" />
            <LocationGridItem location="Chicago, IL" path="/chicago" id="8" />
            <LocationGridItem location="Colorado" path="/colorado" id="3" />
            <LocationGridItem location="Providence, RI" path="/providence" id="20" />
            <LocationGridItem location="California" path="/california" id="21" />
            <LocationGridItem location="Columbus, OH" path="/columbus" id="2" />
            <LocationGridItem location="Portland, OR" path="/portland" id="5" />
            <LocationGridItem location="Texas" path="/texas" id="15" />
            <LocationGridItem location="Memphis, TN" path="/memphis" id="13" />
            <LocationGridItem location="Iowa" path="/iowa" id="22" />
            <LocationGridItem location="Arlington, VA" path="/arlington" id="14" />
            <LocationGridItem location="St. Pete Beach, FL" path="/st-pete-beach" id="4" />
            <LocationGridItem location="Wichita, KS" path="/wichita" id="23" />
          </section>
        </article>
      </div>
    )
  }
}

export default LocationGrid


// WEBPACK FOOTER //
// ./src/components/LocationGrid/index.js